import { render, staticRenderFns } from "./NbReset.vue?vue&type=template&id=632d2c4c"
import script from "./NbReset.vue?vue&type=script&lang=js"
export * from "./NbReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports